// extracted by mini-css-extract-plugin
export default {"row":"Ratings_row__4CPDH","column":"Ratings_column__aiCG5","title":"Ratings_title__o+5ix","label":"Ratings_label__AJB-0"};